export * from './projectOverview.service';
import { ProjectOverviewService } from './projectOverview.service';
export * from './projectOverview.serviceInterface';
export const APIS = [ProjectOverviewService];
